import { DefaultTheme } from 'styled-components';
import { Breakpoint } from '../../theme';
import { ColumnsByBreakpoint } from './types';

export const updateThemeColumns = (
  themeToUpdate: DefaultTheme,
  columnsByBreakpoint: Partial<ColumnsByBreakpoint>
): DefaultTheme => {
  const updatedBreakpoints = Object.fromEntries(
    Object.entries(columnsByBreakpoint)
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      .filter(([breakpoint, noOfColumns]) => !!noOfColumns)
      .map(([breakpoint, noOfColumns]) => {
        return [
          breakpoint,
          {
            ...themeToUpdate.layout[breakpoint as Breakpoint],
            columns: noOfColumns,
          },
        ];
      })
  );

  return {
    ...themeToUpdate,
    layout: {
      ...themeToUpdate.layout,
      ...updatedBreakpoints,
    },
  };
};
